import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './auth/AuthContext';
import App from './App';
import { SignedInTelemetry } from './telemetry/SignedInTelemetry';
import './theme/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <SignedInTelemetry />
      <App />
    </AuthProvider>
  </StrictMode>
);
